// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategorySearchV2 {
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 50;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(0 0 0 / 0.1);
}

.CategorySearchV2 .contents {
    position: relative;
    border-radius: 0.5rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1.5rem;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    max-width: 80vw;
    --tw-translate-y: -1rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.CategorySearchV2 .contents .close {
    position: absolute;
    right: -1.25rem;
    top: -1.25rem;
    display: flex;
    height: 1.5rem;
    width: 1.5rem;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 9999px;
    background-color: rgb(255 255 255 / 0.5);
}
.CategorySearchV2 .contents .close > * {
    width: 1rem;
    stroke-width: 1;
    color: rgb(0 0 0 / 0.9);
}
.CategorySearchV2 .contents {
}
.CategorySearchV2 .contents .items {
    display: flex;
    gap: 1rem;
}
.CategorySearchV2 .contents .items .list {
}

/** CategoryList */
.CategoryList {
    position: relative;
    height: 70vh;
    border-left-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.CategoryList:first-child {
    border-style: none;
}
.CategoryList {
    overflow-y: auto;
}
.CategoryList .backButton {
    margin-left: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: 0.9rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.CategoryList .backButton .icon * {
    /* @apply stroke-primary-orange; */
}
.CategoryList .item {
    padding: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    display: flex;
    min-width: 200px;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.CategoryList .item.active .title {
    /* @apply bg-bgs-lightGray/10; */
    --tw-text-opacity: 1;
    color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}

.CategoryList .item:hover .title {
    /* @apply bg-bgs-lightGray/10; */
    --tw-text-opacity: 1;
    color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.CategoryList .item .title {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.9rem;
}
.CategoryList .item .icon {
    cursor: pointer;
    border-radius: 0.75rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.CategoryList .item.active .icon *,
.CategoryList .item:hover .icon * {
    stroke: #f97316;
}

.CategoryList .search {
    position: relative;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-bottom: 0.25rem;
    position: sticky;
    top: 0px;
    left: 0px;
}
.CategoryList .search input {
}
.CategoryList .search .closeButton {
    position: absolute;
    right: 1rem;
    top: 50%;
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    display: flex;
    height: 1.5rem;
    width: 1.5rem;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 9999px;
    background-color: rgb(255 255 255 / 0.5);
}
.CategoryList .search .closeButton > * {
    width: 1rem;
    stroke-width: 1;
    color: rgb(0 0 0 / 0.9);
}

/* Breadcumb */
.CategorySearchV2 .contents .items .breadcumb {
    position: absolute;
    left: 0px;
    top: 100%;
    --tw-translate-y: 0.5rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border-radius: 0.5rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.CategorySearchV2 .contents .items .breadcumb .breadcumbItem {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/CategorySearchV2/CategorySearchV2.css"],"names":[],"mappings":"AACI;IAAA,eAA4C;IAA5C,SAA4C;IAA5C,QAA4C;IAA5C,WAA4C;IAA5C,YAA4C;IAA5C,WAA4C;IAC5C,aAAuC;IAAvC,mBAAuC;IAAvC,uBAAuC;IACvC;AAF4C;;AAM5C;IAAA,kBAAiD;IAAjD,qBAAiD;IAAjD,kBAAiD;IAAjD,4DAAiD;IAAjD,eAAiD;IAAjD,+EAAiD;IAAjD,mGAAiD;IAAjD,uGAAiD;IACjD,eAAmB;IACnB,uBAAqB;IAArB;AAFiD;AAKjD;IAAA,kBAA+B;IAA/B,eAA+B;IAA/B,aAA+B;IAC/B,aAA+C;IAA/C,cAA+C;IAA/C,aAA+C;IAA/C,mBAA+C;IAA/C,uBAA+C;IAC/C,eAA8C;IAA9C,qBAA8C;IAA9C;AAF+B;AAK/B;IAAA,WAAiC;IAAjC,eAAiC;IAAjC;AAAiC;AAErC;AACA;AAEI;IAAA,aAAiB;IAAjB;AAAiB;AAErB;AACA;;AAEA,kBAAkB;AAEd;IAAA,kBAA8E;IAA9E,YAA8E;IAA9E,sBAA8E;IAA9E,sBAA8E;IAA9E,4DAA8E;IAA9E,oBAA8E;IAA9E;AAA8E;AAA9E;IAAA;AAA8E;AAC9E;IAAA;AAAsB;AAGtB;IAAA,mBAAoF;IAApF,aAAoF;IAApF,mBAAoF;IAApF,WAAoF;IAApF,mBAAoF;IAApF,sBAAoF;IAApF,iBAAoF;IAApF,gBAAoF;IAApF,oBAAoF;IAApF;AAAoF;AAExF;IACI,kCAAkC;AACtC;AAEI;IAAA,aAAe;IAAf,mBAAe;IAAf,sBAAe;IACf,aAAsD;IAAtD,gBAAsD;IAAtD,mBAAsD;IAAtD,8BAAsD;IAGtD,eAAgC;IAAhC,oBAAgC;IAAhC;AAJe;AAMnB;IACI,gCAAgC;IAChC,oBAAsB;IAAtB,kDAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,oBAAsB;IAAtB,kDAAsB;AAC1B;AAEI;IAAA,kBAAyB;IAAzB,mBAAyB;IAAzB;AAAyB;AAGzB;IAAA,eAAqC;IAArC,sBAAqC;IAArC,oBAAqC;IAArC;AAAqC;;AAKrC;;IAAA;AAAwB;;AAIxB;IAAA,kBAAkC;IAAlC,kBAAkC;IAAlC,4DAAkC;IAAlC,oBAAkC;IAAlC,qBAAkC;IAAlC,uBAAkC;IAClC,gBAA0B;IAA1B,QAA0B;IAA1B;AADkC;AAGtC;AACA;AAEI;IAAA,kBAAgD;IAAhD,WAAgD;IAAhD,QAAgD;IAAhD,sBAAgD;IAAhD,+LAAgD;IAChD,aAA+C;IAA/C,cAA+C;IAA/C,aAA+C;IAA/C,mBAA+C;IAA/C,uBAA+C;IAC/C,eAA8C;IAA9C,qBAA8C;IAA9C;AAFgD;AAKhD;IAAA,WAAiC;IAAjC,eAAiC;IAAjC;AAAiC;;AAGrC,cAAc;AAEV;IAAA,kBAA6C;IAA7C,SAA6C;IAA7C,SAA6C;IAA7C,wBAA6C;IAA7C,+LAA6C;IAC7C,aAA8B;IAA9B,mBAA8B;IAA9B,WAA8B;IAC9B,qBAA6C;IAA7C,kBAA6C;IAA7C,4DAA6C;IAA7C,aAA6C;IAA7C,mBAA6C;IAA7C,sBAA6C;IAA7C,+EAA6C;IAA7C,mGAA6C;IAA7C;AAF6C;AAK7C;IAAA,aAA8B;IAA9B,mBAA8B;IAA9B;AAA8B","sourcesContent":[".CategorySearchV2 {\n    @apply fixed w-full h-full left-0 top-0 z-50;\n    @apply flex items-center justify-center;\n    @apply bg-black/10;\n}\n\n.CategorySearchV2 .contents {\n    @apply relative p-6 bg-white rounded-lg shadow-lg;\n    @apply max-w-[80vw];\n    @apply -translate-y-4;\n}\n.CategorySearchV2 .contents .close {\n    @apply absolute -right-5 -top-5;\n    @apply w-6 h-6 flex items-center justify-center;\n    @apply bg-white/50 rounded-full cursor-pointer;\n}\n.CategorySearchV2 .contents .close > * {\n    @apply stroke-1 w-4 text-black/90;\n}\n.CategorySearchV2 .contents {\n}\n.CategorySearchV2 .contents .items {\n    @apply flex gap-4;\n}\n.CategorySearchV2 .contents .items .list {\n}\n\n/** CategoryList */\n.CategoryList {\n    @apply relative h-[70vh] border-l first:border-none border-gray-300 text-black;\n    @apply overflow-y-auto;\n}\n.CategoryList .backButton {\n    @apply ml-6 py-2 flex gap-2 items-center text-[0.9rem] font-semibold text-orange-500;\n}\n.CategoryList .backButton .icon * {\n    /* @apply stroke-primary-orange; */\n}\n.CategoryList .item {\n    @apply p-4 py-2;\n    @apply flex items-center justify-between min-w-[200px];\n}\n.CategoryList .item {\n    @apply text-black cursor-pointer;\n}\n.CategoryList .item.active .title {\n    /* @apply bg-bgs-lightGray/10; */\n    @apply text-orange-500;\n}\n\n.CategoryList .item:hover .title {\n    /* @apply bg-bgs-lightGray/10; */\n    @apply text-orange-500;\n}\n.CategoryList .item .title {\n    @apply px-4 text-[0.9rem];\n}\n.CategoryList .item .icon {\n    @apply px-2 rounded-xl cursor-pointer;\n}\n\n.CategoryList .item.active .icon *,\n.CategoryList .item:hover .icon * {\n    @apply stroke-orange-500;\n}\n\n.CategoryList .search {\n    @apply px-2 pb-1 relative bg-white;\n    @apply sticky top-0 left-0;\n}\n.CategoryList .search input {\n}\n.CategoryList .search .closeButton {\n    @apply absolute right-4 top-1/2 -translate-y-1/2;\n    @apply w-6 h-6 flex items-center justify-center;\n    @apply bg-white/50 rounded-full cursor-pointer;\n}\n.CategoryList .search .closeButton > * {\n    @apply stroke-1 w-4 text-black/90;\n}\n\n/* Breadcumb */\n.CategorySearchV2 .contents .items .breadcumb {\n    @apply absolute left-0 top-full translate-y-2;\n    @apply flex gap-2 items-center;\n    @apply p-4 py-2 bg-white rounded-lg shadow-lg;\n}\n.CategorySearchV2 .contents .items .breadcumb .breadcumbItem {\n    @apply flex gap-2 items-center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
